import { __DEV__, __PROD__ } from './asserts';
const logStack = new Set();
export function warn(message, component) {
    const tag = component ? `[${component}]` : ' ';
    const msg = `[VulcanUI]${tag} ${message}`;
    if (logStack.has(msg) && __PROD__)
        return;
    logStack.add(msg);
    if (__DEV__)
        console.error(msg);
    else
        console.warn(msg);
}
export function error(message, component) {
    const tag = component ? `[${component}]` : ' ';
    const msg = `[VulcanUI]${tag} ${message}`;
    if (logStack.has(msg) && __PROD__)
        return;
    logStack.add(msg);
    if (__DEV__)
        throw new Error(msg);
    else
        console.error(msg);
}
//# sourceMappingURL=console.js.map